import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { ListPopUpSignin } from 'app/shared/models/class/list-link/list-link';
import { CustomerDetails } from 'app/shared/models/class/user/user';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SetRouteService } from 'app/shared/services/set-route/set-route.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-pop-up-sign-in',
  templateUrl: './pop-up-sign-in.component.html',
  styleUrls: ['./pop-up-sign-in.component.scss']

})
export class PopUpSignInComponent extends SubscriptionBaseComponent implements OnInit {

  isConnectUser: boolean;
  isConnectAdmin: boolean;
  userConnect: InfosUser;

  roles = ['admin', 'AdminCROS', 'AdminMSR', 'AdminSITE'];
  @Input()  user: CustomerDetails;


  listLink: ListPopUpSignin[] = [
    {
      name: 'Mes informations personnelles',
      url: '/home/personal-information'
    },
    // {
    //   name: 'Historique de mes réservations',
    //   url: '/home/purchases-history'
    // },
    // {
    //   name: 'Mes stagiaires',
    //   url: '/home/my-trainees'
    // },
  ];

  constructor(
    private dataService: DataService,
    public router: Router,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private setRouteService: SetRouteService,
    private faIconService: FaiconService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  close(): void {
    this.dataService.resetPopUp();
  }

  changeRoute(): void {
    this.dataService.popUpSignIn.next(false);
  }

  logout(): void {
    this.setRouteService.setRouteSessionStrorage('/home');
    this.authService.logout();
    this.dataService.popUpSignIn.next(false);
    this.authService.currentUser.next(null);
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.isConnectAdmin.asObservable().subscribe({
          next: isConnectAdmin => { this.isConnectAdmin = isConnectAdmin; this.cdr.detectChanges(); }
        })
      ).add(
        this.authService.currentUser.asObservable().subscribe({
          next: user => {
            if (user === null) {
              this.user = null;
            }
            this.userConnect = user;
            this.cdr.detectChanges();
          },
        })
      );
  }

}
